import { FetchResponse } from "shared-components";

import { actionHandler } from "../action-handler";
import { clientGet, clientPost } from "../client";
import { Report } from "./model";

interface ReportDto {
  productId: string;
  cause: string;
  description: string;
}

export const createReport = actionHandler(
  async ({ productId, ...payload }: ReportDto): Promise<FetchResponse<null>> => {
    return clientPost({ path: `report/${productId}`, payload });
  },
);

export const getProductReports = actionHandler(async (productId: string): Promise<Report> => {
  return clientGet({ path: `report/${productId}` });
});
